@if (viewSpinner()) {
  <app-spinner />
} @else {
  <main class="card">
    <section class="cardHeaderTable animated">
      <h3>{{ titulo() }}</h3>

      @if (isSpinner()) {
        <div class="boxBtns">
          @if (isVisibleBtnDescargar()) {
            @if (isDescargando()) {
              <button matTooltip="Descargar" class="btnBorderWithIcon" (click)="estaSeguroDescargarArchivo()" style="margin-right: 0.5rem">
                <mat-icon fontIcon="download"></mat-icon>
                Descargar
              </button>
            } @else {
              <button matTooltip="Descargando" class="btnBorderWithIcon" style="margin-right: 0.5rem">
                <div class="descargando">
                  <mat-icon fontIcon="refresh"></mat-icon>
                  <span>Descargando</span>
                </div>
              </button>
            }
          }

          @if (isVisibleBtnColumnas()) {
            <div class="btnColums">
              <button class="btnBorderWithIcon" (click)="isShowColumn = !isShowColumn">
                <mat-icon fontIcon="settings"></mat-icon>
                Columnas
              </button>

              @if (isShowColumn) {
                <div class="checkedOptions">
                  @for (item of listDataColumns(); track item.id) {
                    @if (item.title !== 'id') {
                      <mat-checkbox [checked]="item.checked" (click)="toggleCheckbox($event, item)">
                        {{ item.title | titlecase }}
                      </mat-checkbox>
                    }

                  } @empty {
                    <div class="checkEmpty" (click)="isShowColumn = !isShowColumn" (keyup)="isShowColumn = !isShowColumn" tabindex="-1">
                      <p>No hay columnas disponibles para mostrar</p>
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    </section>

    @if (isSpinner() && isVisiblePagination() === true) {
      <mat-paginator
        [length]="totalItems"
        [pageSize]="pageSize"
        [pageIndex]="pageIndex"
        [pageSizeOptions]="[5, 10, 25, 50, 100]"
        [showFirstLastButtons]="true"
        (page)="onPageChange($event)"
      >
      </mat-paginator>
    }

    @if (isSpinner()) {
      <section class="boxTable">
        <table class="tabla animated">
          @if (isVisibleTableHeader()) {
            <thead class="sticky-header">
              <tr (click)="clickAction()">
                @if (isVisibleActions()) {
                  <th style="border-right: 1px solid #d6d6d6">
                    <div class="acciones">Acciones</div>
                  </th>
                }

                @for (col of columnsHeaderTable; track col) {
                  <th>
                    @if (col !== 'id') {
                      <div class="headerColumns" (click)="orderBy(col)" tabindex="-1" (keyup)="orderByEcvent($event, col)">
                        <p>{{ col | titlecase }}</p>
                        <div class="iconArrows">
                          @if (sortedColumn === col && sortDirection === 'asc') {
                            <mat-icon fontIcon="north"></mat-icon>
                          } @else if (sortedColumn === col && sortDirection === 'desc') {
                            <mat-icon fontIcon="south"></mat-icon>
                          } @else {
                            <mat-icon fontIcon="north"></mat-icon>
                          }
                        </div>
                      </div>
                    }
                  </th>
                }
              </tr>

              <tr (click)="clickAction()">
                <th style="border-right: 1px solid #ccc; width: 150px"></th>

                @for (item of columnsHeaderTable; track $index) {
                  <th>
                    @if (item !== 'id') {
                      <form [formGroup]="filterTableForm">
                        <div class="searchForm">
                          <input matInput [formControlName]="item" placeholder="Buscar" (keyup)="handleKeyup($event)" tabindex="-1" />
                          <mat-icon matTooltip="Buscar" fontIcon="search" (click)="busquedaAnidada()"></mat-icon>
                        </div>
                      </form>
                    }
                  </th>
                }

                <!-- @for (item of columnsHeaderTable; track $index;) {
                <th>
                  @if (item !== 'id') {
                    <form [formGroup]="filterTableForm">
                      <div class="searchForm">
                        <input
                          matInput
                          [formControlName]="item"
                          placeholder="Buscar"
                          (keyup)="handleKeyup($event)"
                          (keydown)="item === 'Código' ? onlyAllowNumbers($event) : null"
                          tabindex="-1"
                        >
                        <mat-icon matTooltip="Buscar" fontIcon="search" (click)="busquedaAnidada()"></mat-icon>
                      </div>
                    </form>
                  }
                </th>
              } -->
              </tr>
            </thead>
          }

          @if (isVisibleBodyTable()) {
            @if (listDataTable().length > 0) {
              <tbody>
                <!-- @for(dato of listDataTable; track dato.id ) { -->
                <tr *ngFor="let dato of listDataTable(); let i = index">
                  @if (isVisibleActions()) {
                    <td style="border: 1px solid #d6d6d6">
                      <div class="iconsTable acciones">
                        @for (ac of acciones; track ac) {
                          @if (ac.isSections) {
                            <span [matTooltip]="ac.tooltip ?? ''" (click)="ac.event(dato)" (keyup)="handleKeyup($event)" tabindex="-1">
                              <mat-icon [fontIcon]="ac.icon ?? ''"></mat-icon>
                            </span>
                          }

                          @if (ac.isRedirectToChild) {
                            <span [matTooltip]="ac.tooltip ?? ''" (click)="ac.event(dato)" (keyup)="handleKeyup($event)" tabindex="-1">
                              <mat-icon [fontIcon]="ac.icon ?? ''"></mat-icon>
                            </span>
                          }

                          @if (ac.isBtnVert) {
                            <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="menu">
                              <mat-icon>more_vert</mat-icon>
                            </button>

                            <mat-menu #menu="matMenu">
                              @for (item of routeSelectFn; track $index) {
                                <button mat-menu-item (click)="ac.event(dato, item.path)" class="buttonSelect">{{ item.label }}</button>
                              }
                            </mat-menu>
                          }

                          @if (ac.isVisualizar) {
                            @if (dato.isIcon !== 'visualizar') {
                              <span [matTooltip]="ac.tooltip ?? ''" (click)="ac.event(dato)" (keyup)="ac.event(dato)" tabindex="-1">
                                <mat-icon [fontIcon]="ac.icon ?? ''"></mat-icon>
                              </span>
                            } @else {
                              <span style="cursor: not-allowed">
                                <mat-icon style="color: #ccc" [fontIcon]="ac.icon ?? ''"></mat-icon>
                              </span>
                            }
                          }

                          @if (allowModificar()) {
                            @if (ac.isEdit) {
                              @if (dato.isIcon !== 'edit') {
                                <span [matTooltip]="ac.tooltip ?? ''" (click)="ac.event(dato)" (keyup)="ac.event(dato)" tabindex="-1">
                                  <mat-icon [fontIcon]="ac.icon ?? ''"></mat-icon>
                                </span>
                              } @else {
                                <span style="cursor: not-allowed">
                                  <mat-icon style="color: #ccc" [fontIcon]="ac.icon ?? ''"></mat-icon>
                                </span>
                              }
                            }
                          }

                          @if (allowBaja()) {
                            @if (ac.isDelete) {
                              @if (dato.isIcon !== 'delete') {
                                <span matTooltip="Borrar" (click)="ac.event(dato)" (keyup)="ac.event(dato)" tabindex="-1">
                                  <mat-icon [fontIcon]="ac.icon ?? ''"></mat-icon>
                                </span>
                              } @else {
                                <span style="cursor: not-allowed">
                                  <mat-icon style="color: #ccc" [fontIcon]="ac.icon ?? ''"></mat-icon>
                                </span>
                              }
                            }
                          }
                        }
                      </div>
                    </td>
                  }

                  @for (item of columnsHeaderTable; track $index) {
                    <td>
                      @if (item !== 'id') {
                        {{ dato[item] }}
                      }
                    </td>
                  }
                </tr>
              </tbody>
            }
          } @else {
            <app-info-message />
          }
        </table>
      </section>
    } @else {
      <app-cargando />
    }
  </main>
}
